import { useAuth } from '../../hooks/useAuth';
import { User, Mail, Calendar, Shield } from 'lucide-react';

export default function Settings() {
  const { user, userData } = useAuth();

  return (
    <div className="space-y-8">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Account Settings</h1>
        <p className="mt-2 text-gray-600">Manage your account information and preferences</p>
      </div>

      {/* Account Information */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-6">Account Information</h2>

        <div className="space-y-4">
          {/* Name */}
          <div className="flex items-center">
            <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
              <User className="h-6 w-6 text-blue-600" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Name</p>
              <p className="text-base text-gray-900">
                {userData?.name || user?.displayName || 'Not set'}
              </p>
            </div>
          </div>

          {/* Email */}
          <div className="flex items-center">
            <div className="flex-shrink-0 w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
              <Mail className="h-6 w-6 text-green-600" />
            </div>
            <div className="ml-4 flex-1">
              <p className="text-sm font-medium text-gray-600">Email</p>
              <div className="flex items-center">
                <p className="text-base text-gray-900">{user?.email}</p>
                {user?.emailVerified ? (
                  <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                    Verified
                  </span>
                ) : (
                  <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-amber-100 text-amber-800">
                    Not verified
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Account Created */}
          <div className="flex items-center">
            <div className="flex-shrink-0 w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
              <Calendar className="h-6 w-6 text-purple-600" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Member Since</p>
              <p className="text-base text-gray-900">
                {user?.metadata?.creationTime
                  ? new Date(user.metadata.creationTime).toLocaleDateString('en-ZA', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })
                  : 'Unknown'}
              </p>
            </div>
          </div>

          {/* Role */}
          {userData?.role && (
            <div className="flex items-center">
              <div className="flex-shrink-0 w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center">
                <Shield className="h-6 w-6 text-indigo-600" />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">Role</p>
                <p className="text-base text-gray-900 capitalize">{userData.role}</p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Coming soon section */}
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200 p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Coming Soon</h3>
        <ul className="space-y-2 text-sm text-gray-700">
          <li className="flex items-center">
            <span className="text-blue-500 mr-2">•</span>
            Update profile information
          </li>
          <li className="flex items-center">
            <span className="text-blue-500 mr-2">•</span>
            Change password
          </li>
          <li className="flex items-center">
            <span className="text-blue-500 mr-2">•</span>
            Email preferences
          </li>
          <li className="flex items-center">
            <span className="text-blue-500 mr-2">•</span>
            Notification settings
          </li>
          <li className="flex items-center">
            <span className="text-blue-500 mr-2">•</span>
            Delete account
          </li>
        </ul>
      </div>
    </div>
  );
}
